import { GridConfig } from './GridConfig';
import { Column, ColumnKeys } from '../types';
import { BaseWebComponentView } from '../../../../framework/BaseWebComponentView';
import { DeployerGridRelay } from '../types/deployer-grid-relay';
import { GridViewWebComponent } from '../../../../grid/gridView';
import { GridViewMetadata, ViewConfiguration, ViewType } from '../../../../grid/gridView/types';
import { WEB_COMPONENT_GRID_VIEW, WEB_COMPONENT_GZ_INFO_BOX } from '../../../../webcomponents.constants';
import { GridEvents } from '../../../../grid/types/common';
import { GzInfoBoxWebComponent } from '../../../../ui/gzInfoBox';
import { InfoBoxSeverity } from '../../../../ui/gzInfoBox/types';
import { translateFn } from '../../../../utils/translator.helper';

export class DeployerGridView extends BaseWebComponentView {
  public dom: {
    $wrapper: HTMLElement;
    $grid: GridViewWebComponent<Column, ColumnKeys, DeployerGridRelay>;
    $warningMessage: GzInfoBoxWebComponent;
  };

  getDomElements(): void {
    this.dom = {
      $wrapper: this.shadow.querySelector('.wrapper'),
      $grid: this.shadow.querySelector(WEB_COMPONENT_GRID_VIEW) as GridViewWebComponent<Column, ColumnKeys>,
      $warningMessage: this.shadow.querySelector(WEB_COMPONENT_GZ_INFO_BOX),
    };

    if (this.dom.$grid.injectDependencies) {
      this.dom.$grid.injectDependencies(this.dependencies);
      this.dom.$grid.start().then().catch(console.error);
    }

    this.getTranslations();
    this.setTranslatedStrings();
  }

  setTranslatedStrings(): void {
    this.dom.$warningMessage.innerHTML = translateFn('You need to select one Endpoint Security Relay');
  }

  async buildSuccessView(): Promise<void> {
    this.dom.$warningMessage.severity = InfoBoxSeverity.WARNING;
    const { viewMetaData } = new GridConfig().getDataForView(this.dependencies, this.dom.$grid);
    this.buildGrid(viewMetaData);
  }

  private buildGrid(viewMetaData: GridViewMetadata<Column, ColumnKeys>): void {
    const grid = this.dom.$grid;
    grid.propertiesSet = false;

    const defaultViewProps: ViewConfiguration<Column, ColumnKeys> = {
      compactView: viewMetaData.isCompactViewChecked,
      displayedColumns: viewMetaData.columns,
      filters: viewMetaData.filters,
      name: '',
      pageSize: viewMetaData.pageSize,
      type: ViewType.DEFAULT,
      id: viewMetaData.viewId,
    };

    grid.inlineRowActions = [
      {
        title: translateFn('Edit custom server name/IP'),
        value: GridEvents.EDIT_ROW,
      },
    ];

    grid.customStrings = {
      noSearchResultsString: translateFn('No relays found'),
    };
    for (const [key, value] of Object.entries(viewMetaData)) {
      grid[key] = value;
    }
    grid.showGlobalActions = false;
    grid.defaultViewProps = defaultViewProps;
    grid.propertiesSet = true;
  }
}
